// BotAvatar.js
import React from "react";

const BotAvatar = () => {
  return (
    <div
      style={{
        background: "#2563eb", // blue background
        color: "#fff",
        borderRadius: "50%",
        width: "40px",
        height: "40px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: "bold",
      }}
    >
      N 
    </div>
  );
};

export default BotAvatar;
